import { render, staticRenderFns } from "./PatentForm.vue?vue&type=template&id=7b6b93e9&"
import script from "./PatentForm.vue?vue&type=script&lang=js&"
export * from "./PatentForm.vue?vue&type=script&lang=js&"
import style0 from "./PatentForm.vue?vue&type=style&index=0&id=7b6b93e9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports